/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Data access levels */
export enum DataAccessLevel {
  Public,
  Internal,
  Confidential,
  Restricted,
  TopSecret,
}

export type DataAccessLevelArgs = DataAccessLevel;

export function getDataAccessLevelEncoder(): FixedSizeEncoder<DataAccessLevelArgs> {
  return getEnumEncoder(DataAccessLevel);
}

export function getDataAccessLevelDecoder(): FixedSizeDecoder<DataAccessLevel> {
  return getEnumDecoder(DataAccessLevel);
}

export function getDataAccessLevelCodec(): FixedSizeCodec<
  DataAccessLevelArgs,
  DataAccessLevel
> {
  return combineCodec(getDataAccessLevelEncoder(), getDataAccessLevelDecoder());
}
